import { WorkspaceMigrationStatusCodes } from "../models/IAsyncWrapper/WorkspaceMigrationModels.js";
const hasEntityBeenMigrated = (result) => {
  var _a;
  return (result == null ? void 0 : result.statusCode) === WorkspaceMigrationStatusCodes.MovedPermanently || ((_a = result == null ? void 0 : result.errorContext) == null ? void 0 : _a.statusCode) === WorkspaceMigrationStatusCodes.MovedPermanently;
};
const isMigrationErrorStatusCode = (result) => {
  var _a, _b;
  return ((_a = result == null ? void 0 : result.errorContext) == null ? void 0 : _a.statusCode) === WorkspaceMigrationStatusCodes.MethodNotAllowed || ((_b = result == null ? void 0 : result.errorContext) == null ? void 0 : _b.statusCode) === WorkspaceMigrationStatusCodes.NotAcceptable;
};
export {
  hasEntityBeenMigrated,
  isMigrationErrorStatusCode
};
//# sourceMappingURL=WorkspaceMigration.utils.js.map
